import qs from 'query-string'
import deleteRequest from 'utils/deleteRequest'

import getRequest from 'utils/getRequest'
import patchRequest from 'utils/patchRequest'
import postRequest from 'utils/postRequest'
import putRequest from 'utils/putRequest'

const path = '/api/monitoring'
import filterNullAndUndefinedFieldsFromObject from 'utils/filterNullAndUndefinedFieldsFromObject'

//eslint-disable-next-line
export const requestGetSites = ({
  // eslint-disable-next-line no-magic-numbers
  resultsPerPage = 12,
  // eslint-disable-next-line no-magic-numbers
  currentPage = 1,
  siteStatus = '',
  year = '',
  country = '',
  sortBy = 'name',
  sortDirection = 'ASC',
  toggle = false,
  signal
}) => {
  const queryString = {
    resultsPerPage,
    currentPage,
    siteStatus,
    year,
    country,
    sortBy,
    toggle,
    sortDirection
  }
  const queryStringParsed = qs.stringify(queryString)
  return getRequest(`${path}/?${queryStringParsed}`, signal)
}

export const requestSiteMonitoring = (siteId, monitor_users_id) => {
  return postRequest(path, { siteId, monitor_users_id })
}

export const requestValidateMonitoring = (monitoringId) => {
  return postRequest(`${path}/${monitoringId}/validate`)
}

export const requestUpdateMonitoring = async (monitoringId, data) => {
  return await postRequest(`${path}/${monitoringId}`, data)
}

export const monitoringQtySpr = async () => {
  return await getRequest(`/api/monitor-quality-spr`)
}

export const getStateCategory = async () => {
  return await getRequest(`/api/state-category`)
}
export const getMonitoringParameter = async (speciesId, siteId) => {
  return await getRequest(`/api/trigger-benchmark-parameter-history/?species_id=${speciesId}&site_id=${siteId}`)
}

export const getStateCategorySource = async () => {
  return await getRequest(`/api/state-category-source`)
}

export const getResponseDesignation = async () => {
  return await getRequest(`/api/response-designation`)
}
export const getResponseAction = async () => {
  return await getRequest(`/api/response-action`)
}

export const getResponsePlanning = async () => {
  return await getRequest(`/api/response-planning`)
}
export const getResponseLevelOneAction = async () => {
  return await getRequest(`/api/level1-actions`)
}
export const getResponseLevelTwoAction = async () => {
  return await getRequest(`/api/level2-actions`)
}
export const getResponseLevelThreeAction = async () => {
  return await getRequest(`/api/level3-actions`)
}
export const getStateCategoryTyps = async () => {
  return await getRequest(`/api/state-evaluation-typs`)
}

export const getResponseByMonitoringId = async (monitoring_id) => {
  return await getRequest(`/api/site-response/monitoring/${monitoring_id}`)
}

export const requestSiteResponse = (monitoring_id) => {
  return postRequest(`/api/site-response`, { monitoring_id })
}

export const requestUpdateSiteResponse = (response_id, payload) => {
  return patchRequest(`/api/site-response/${response_id}`, payload)
}

export const getMonitoringResponseActionsBySiteResponse = async (response_id, monitoringId) => {
  return await getRequest(`/api/monitor-response-actions/${response_id}/site-response?monitoring_id=${monitoringId}`)
}

export const requestMonitorResponseAction = async (payload) => {
  return postRequest(`/api/monitor-response-actions`, payload)
}

export const deleteMonitorResponseAction = async (monitor_response_id) => {
  return deleteRequest(`/api/monitor-response-actions/${monitor_response_id}`)
}

export const requestUpdateMonitorResponseAction = async (monitor_response_id, payload) => {
  return patchRequest(`/api/monitor-response-actions/${monitor_response_id}`, payload)
}

export const getAboutMonitoring = async (monitoringId) => {
  return await getRequest(`${path}/${monitoringId}`)
}

export const getStateEvaluationById = async (id) => {
  return await getRequest(`/api/trigger-state-evaluation/${id}`)
}

export const updateStateEvaluation = async (id, payload) => {
  return await patchRequest(`/api/trigger-state-evaluation/${id}`, payload)
}

export const requestUpdateSiteFiles = async (monitoringId, formData) => {
  const url = `${path}/${monitoringId}`
  const response = await fetch(url, {
    method: 'POST',
    body: formData,
    headers: {
      Accept: 'application/json'
    }
  })
  return response.json()
}

export const monitoringStateBio = async ({ siteId, filterBy, page, limit, monitoringId }) => {
  try {
    // Attempt GET request with body
    const res = await fetch(`/api/state-evaluation-typs/biodiversity`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ siteId, filterBy })
    })

    if (res.ok) return res.json()

    throw new Error('Primary GET with body failed')
  } catch (_) {
    // Fallback → normal GET with query params
    const fallbackRes = await fetch(
      `/api/state-evaluation-typs/biodiversity?monitoringId=${monitoringId}&siteId=${siteId}&filterBy=${filterBy}&page=${page}&limit=${limit}`
    )

    return fallbackRes.json()
  }
}

export const requestCreateSiteState = (monitoringId) => {
  if (!monitoringId) {
    throw new Error('monitoringId is required to create a site state record')
  }

  const parsedMonitoringId = Number(monitoringId)
  const monitoringIdPayload = Number.isNaN(parsedMonitoringId) ? monitoringId : parsedMonitoringId

  return postRequest('/api/site-state', { monitoring_id: monitoringIdPayload })
}

export const requestGetSiteState = (siteStateId) => {
  if (!siteStateId) {
    throw new Error('siteStateId is required to fetch a site state record')
  }
  return getRequest(`/api/site-state/monitoring/${siteStateId}`)
}

export const requestGetOrCreateSiteState = async ({ siteStateId, monitoringId } = {}) => {
  if (!siteStateId && !monitoringId) {
    throw new Error('Either siteStateId or monitoringId is required to get or create a site state record')
  }

  if (siteStateId) {
    try {
      const response = await requestGetSiteState(siteStateId)
      if (response?.id) {
        return response
      }
    } catch (error) {
      console.warn('[SiteState] Failed to fetch existing site state, will attempt create', error)
    }
  }

  if (!monitoringId) {
    throw new Error('monitoringId is required to create a site state record')
  }

  return requestCreateSiteState(monitoringId)
}

export const requestTriggerStateBenchmark = async (payload = []) => {
  if (!Array.isArray(payload) || payload.length === 0) {
    throw new Error('payload array with at least one entry is required to trigger state benchmark')
  }

  return postRequest('/api/trigger-state-benchmark', payload)
}

export const requestTriggerStateBenchmarkTaxonGroups = async (payload = {}) => {
  if (!payload || !Array.isArray(payload.class_names) || payload.class_names.length === 0) {
    throw new Error('valid payload object with class_names array is required to trigger state benchmark taxon groups')
  }

  return postRequest('/api/trigger-state-benchmark/taxon-groups', payload)
}

export const updateTriggerStateBenchmark = async (id, payload) => {
  if (!id) throw new Error('triggerStateBenchmark id is required to update')
  return await patchRequest(`/api/trigger-state-benchmark/${id}`, payload)
}

export const getTriggerStateBenchmark = async (id) => {
  if (!id) throw new Error('triggerStateBenchmark id is required to fetch')
  return await getRequest(`/api/trigger-state-benchmark/${id}`)
}

export const requestSaveStateEvaluation = async (payload) => {
  if (!payload) {
    throw new Error('Payload is required to save state evaluation')
  }

  return postRequest('/api/trigger-state-evaluation', payload)
}

export const requestDeleteMonitoringFiles = async (monitoringId, fileId) => {
  const url = `${path}/${monitoringId}/deleteMonitoringFiles/${fileId}`
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json'
    }
  })
  return response.json()
}

export const getPressureMonitoring = async (monitoringId) => {
  // return await getRequest(`/api/site-pressure/${monitoringId}/getSitePressureByMonitor`)
  return await getRequest(`/api/site-pressure/${monitoringId}/monitor`)
}

export const getBenchmarkCondition = async () => {
  return await getRequest(`/api/benchmark-condition`)
}

export const createMonitoringPressure = (monitoringId) => {
  if (!monitoringId) {
    throw new Error('monitoringId is required to create a monitoring record')
  }

  const payloadData = {
    monitoring_id: Number(monitoringId)
  }

  return postRequest('/api/site-pressure', payloadData)
}

export const requestGetPressureThreats = async (siteId, pressureId) => {
  const url = `/api/monitor-threats/${pressureId}/site-pressure/${siteId}`
  return await getRequest(url)
}

export const requestGetMonitoringSiteThreats = async (siteId) => {
  const url = `/api/monitoring/${siteId}/site-threats`
  return await getRequest(url)
}

export const requestCreateMonitoringThreat = (pressureId, LevelThreatId) => {
  const preBody = {
    site_pressure_id: Number(pressureId),
    level1_threat_id: LevelThreatId?.Level1ThreatId,
    level2_threat_id: LevelThreatId?.Level2ThreatId,
    level3_threat_id: LevelThreatId?.Level3ThreatId,
    site_threat_timing_id: 3
  }

  const body = filterNullAndUndefinedFieldsFromObject(preBody)
  const url = `/api/monitor-threats`
  return postRequest(url, body)
}

export const requestGetSitePressureSpecies = async (siteId, monitoringId, threatItemId, page, limit) => {
  let url = `/api/site-pressure/site-species?site_id=${siteId}&filter=2&monitor_id=${monitoringId}&monitor_threats_id=${threatItemId}`
  // optional paging params (page, limit)
  try {
    if (page !== undefined && page !== null) {
      url += `&page=${page}`
    }
    if (limit !== undefined && limit !== null) {
      url += `&limit=${limit}`
    }
  } catch (e) {}
  return await getRequest(url)
}

export const requestGetSitePressureEcosystem = async (siteId, monitoringId, threatItemId, page, limit) => {
  let url = `/api/site-pressure/site-ecosystems?site_id=${siteId}&monitor_id=${monitoringId}&monitor_threats_id=${threatItemId}`
  // optional paging params (page, limit)
  try {
    if (page !== undefined && page !== null) {
      url += `&page=${page}`
    }
    if (limit !== undefined && limit !== null) {
      url += `&limit=${limit}`
    }
  } catch (e) {}
  return await getRequest(url)
}

export const requestGetSitePressureEcoSys = async (siteId, monitoringId, threatItemId, page, limit) => {
  let url = `/api/site-pressure/site-ecosystems?site_id=${siteId}&monitor_id=${monitoringId}&monitor_threats_id=${threatItemId}`
  // optional paging params (page, limit)
  try {
    if (page !== undefined && page !== null) {
      url += `&page=${page}`
    }
    if (limit !== undefined && limit !== null) {
      url += `&limit=${limit}`
    }
  } catch (e) {}
  return await getRequest(url)
}

export const requestUpdateMonitoringThreat = async (pressureId, threatId, LevelThreatId) => {
  const preBody = {
    site_pressure_id: Number(pressureId),
    level1_threat_id: LevelThreatId?.Level1ThreatId,
    level2_threat_id: LevelThreatId?.Level2ThreatId,
    level3_threat_id: LevelThreatId?.Level3ThreatId,
    site_threat_timing_id: LevelThreatId?.SiteThreatTimingId
  }
  const body = filterNullAndUndefinedFieldsFromObject(preBody)
  const url = `/api/monitor-threats/${threatId}`
  return patchRequest(url, body)
}

export const requestMarkPressureReviewed = async (threatId) => {
  const url = `/api/monitor-threats/${threatId}/review`
  return patchRequest(url, { is_reviewed: true })
}

export const requestDeleteMonitoringThreat = (threatId) => {
  const url = `/api/monitor-threats/${threatId}`
  return deleteRequest(url)
}

export const requestThreatScope = async () => {
  const url = `/api/threat-scope`
  return await getRequest(url)
}

export const requestThreatSeverity = async () => {
  const url = `/api/threat-severity`
  return await getRequest(url)
}

export const requestDeleteSpeciesThreat = (threatId, monitorThreatId) => {
  const url = `/api/monitor-threats-triggers/${threatId}?monitor_threats_id=${monitorThreatId}`
  return deleteRequest(url)
}

export const requestMonitoringAddOrEdit = async (profileID) => {
  const url = `${path}/${profileID}/user`
  return await getRequest(url)
}
export const requestDeleteMonitoringDraft = (monitoringId) => {
  const url = `${path}/${monitoringId}/supersed`
  return deleteRequest(url)
}

export const requestRevertMonitoringDraft = (monitoringId) => {
  const url = `${path}/${monitoringId}/revert`
  return postRequest(url)
}

export const requestAllEvaluationsForSite = (siteId) => {
  return getRequest(`${path}/${siteId}/site`)
}

export const requestAllThreatTriggers = async (monitorThreatId, filterApi) => {
  const url = `/api/monitor-threats-triggers/${monitorThreatId}/get-all?filter=${filterApi}`
  return await getRequest(url)
}

export const requestPressureCopyPaste = (payload) => {
  const url = `/api/monitor-threats-triggers/copy-paste`
  return postRequest(url, payload)
}

export const createBulkTriggerStateBenchmark = (site_id, site_state_id, filter_by) => {
  if (!site_id || !site_state_id || !filter_by) {
    throw new Error('site_id , site_state_id and filter_by are required to create a monitoring record')
  }

  const payloadData = {
    site_state_id,
    filter_by,
    site_id
  }

  return postRequest('/api/trigger-state-benchmark/bulk-create', payloadData)
}

export const monitoringFinishPropose = (monitoringId) => {
  if (!monitoringId) {
    throw new Error('monitoringId is required to submit evaluation proposal')
  }

  return postRequest(`/api/monitoring/${monitoringId}/finish-propose`)
}

export const requestDeleteMonitorThreatTriggers = async (threatId, payload) => {
  const url = `/api/monitor-threats-triggers/${threatId}/bulk-delete`
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  return response.json()
}

export const requestLevelThreats = async () => {
  const url = `/api/threats`
  return await getRequest(url)
}

export const requestUpdateMonitoringThreatTriggerTimming = async (threatTriggerId, payload) => {
  const url = `/api/monitor-threats/${threatTriggerId}/update-monitor-triggers`
  return await patchRequest(url, payload)
}

export const getMonitoringDashboard = async (monitoringId) => {
  return await getRequest(`${path}/dashboard/${monitoringId}`)
}